
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.104 6.299A15 15 0 1035 20.009v-1.532a1.667 1.667 0 013.334 0v1.533A18.336 18.336 0 0125.198 37.58 18.334 18.334 0 1127.46 3.254 1.667 1.667 0 0126.104 6.3zm11.74-.811c.651.65.652 1.706.001 2.357L21.18 24.528a1.667 1.667 0 01-2.358 0l-5-5a1.667 1.667 0 012.357-2.356l3.82 3.82L35.488 5.49a1.667 1.667 0 012.357-.001z","fill":"#10B981"}})])
          )
        }
      }
    